import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'office-modal-container',
	templateUrl: './modal-container.component.html',
	styleUrls: ['./modal-container.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class OfficeModalContainerComponent {
	@Input() transparent = false;
	@Input() footerBorder = false;
}
